module.exports = __webpack_public_path__ + "img/business_description.9e5a9d73.png";